export default __webpack_public_path__ + "static/indoor23-73a95620fa844da6a1adb51b705b3499.webp";